<template>
  <div className="animated">
    <b-card class="animated fadeIn">
      <b-card-body>
        <h1>Stock en Cámaras</h1>

        <v-server-table :url="url" :columns="columns" :options="options" :theme="theme" ref='table' id="dataTable">
          <template slot="afterFilter">
            <tr class="VueTables__no-results">
              <b-button @click="resetFilters">Limpiar filtro</b-button>
            </tr>

            <tr v-if="loading" class="VueTables__no-results">
              <b-spinner v-if="loading" variant="primary" class="ml-2 mt-1" small label="Small Spinner"></b-spinner>
            </tr>

          </template>

          <div slot="beforeLimit">
            <download-excel
              class="btn"
              :fetch="fetchData"
              :fields="json_fields2"
              worksheet="Stock"
              :name="name"
              :before-generate="startDownload"
              :before-finish="finishDownload">
              <b-link>Descargar</b-link>
            </download-excel>

          </div>


        </v-server-table>
      </b-card-body>
    </b-card>

  </div>

</template>


<script>
  import Vue from 'vue'
  import {ServerTable, Event} from 'vue-tables-2'
  import JsonExcel from 'vue-json-excel'
  import moment from 'moment';
  import numeral from 'numeral';
  import locales from 'numeral/locales'

  numeral.locale('es');
  window.axios = require('axios');


  var d = new Date();

  Vue.use(ServerTable);
  Vue.component('downloadExcel', JsonExcel);

  export default {
    name: 'DataTable',
    components: {
      ServerTable,
    },
    mounted() {
      Event.$on('vue-tables.loading', () => {
        this.loading = true;
      });

      Event.$on('vue-tables.loaded', () => {
        this.loading = false;
      });
    },
    data() {
      return {
        loading: false,
        json_meta: [
          [
            {
              'key': 'charset',
              'value': 'utf-8'
            }
          ]
        ],
        json_fields2: {
          Numero: 'number',
          Posición: 'position',
          Variedades: 'varieties',
          Huertos: 'origins',
          Envase: 'container',
          Cantidad: 'total_quantity',
          KN: {
            field: 'total_net_kilograms',
            callback: (value) => {
              return numeral(parseFloat(value)).format('0.00');
            },
          },
        },
        columns: [
          'number',
          'position',
          'varieties',
          'origins',
          'container',
          'total_net_kilograms',
          // 'total_gross_kilograms',
          // 'total_contents',
          'total_quantity',
        ],
        data: [],
        productSet: [],
        useVuex: false,
        theme: 'bootstrap4',
        template: 'default',
        options: {
          responseAdapter: function (resp) {
            const results = resp.data.results;
            const items = [];
            for (let key in results) {
              const item = results[key];
              results[key].waybill_date = moment(results[key].waybill_date).format('DD-MM-YYYY');
              results[key].net_kilograms = numeral(parseFloat(results[key].net_kilograms));
              items.push(item)
            }

            return {
              data: items,
              count: resp.data.count
            };
          },
          texts: {
            filter: "Filtrar:",
            filterBy: 'Filtrar por {column}',
            count: ' ',
            filterPlaceholder: "Buscar...",
            columns: 'Columnas',
            limit: "Registros:",
          },
          perPage: 10,
          // columnsDropdown: true,
          filterByColumn: true,
          filterable: [
            'number',
            'position',
            'varieties',
            'origins',
            'container',
            'approve',
          ],
          headings: {
            number: 'Numero',
            position: 'Posición',
            total_net_kilograms: 'KN',
            // total_contents: 'Cantidad',
            total_quantity: 'Cantidad',
            varieties: 'Variedades',
            origins: 'Huertos',
            container: 'Formato',
          },
          debounce: 800,
          columnsDropdown: true,
          columnsDisplay: {
            document: 'not_desktop',
            product_name: 'not_desktop',
            product_type_name: 'min_desktop',
            string_specs: 'min_desktop',
            daystay: 'not_desktop',
            condition: 'min_desktop',
            lot_number: 'min_desktop',
            in_process: 'not_desktop',
            last_inspection: 'not_desktop',
          },
          sortable: [],
          sortIcon: {base: 'fa', up: 'fa-sort-asc', down: 'fa-sort-desc', is: 'fa-sort'},
          pagination: {
            dropdown: false,
            chunk: 10
          }
        },

      }
    },
    filters: {
      moment(value) {
        return moment(value).format('DD-MM-YYYY')
      }
    },
    computed: {
      name() {
        return "Stock " + moment(Date.now()).format('YYYYMMDD h:mm') + ".xls"
      },
      url() {
        return '/storage/pallet/?'
      }
    },
    methods: {
      jsonToQueryString(json) {
        var result = {};
        for (var key in json) {
          if (json[key] !== '') {
            result[key] = json[key];
          }
        }

        var a = encodeURIComponent(JSON.stringify(result));

        return '/storage/pallet/?query=' + a;
      },
      resetFilters() {
        for (var key in this.$refs['table'].query) {
          this.$refs['table'].query[key] = '';
        }
        this.$refs['table'].refresh();
      },

      async fetchData() {
        const response = await this.$axios.get(this.jsonToQueryString(this.$refs.table.query));
        return response.data.results;
      },
      startDownload() {
        this.loading = true
      },
      finishDownload() {
        this.loading = false
      },
    },
  };
</script>

<style lang="scss">
  #dataTable {
    width: 100%;
    margin: 0 auto;

    .VuePagination {
      text-align: center;
      justify-content: center;
    }

    .table td {
      padding: 0.30em;
    }

    .vue-title {
      text-align: center;
      margin-bottom: 10px;
    }

    .VueTables__search-field {
      display: flex;
    }

    .VueTables__search-field input {
      margin-left: 0.12rem;
    }

    .VueTables__limit-field {
      display: flex;
    }

    .VueTables__limit-field select {
      margin-left: 0.25rem !important;
    }

    .VueTables__table th {
      text-align: center;
      padding: 0.25rem;
    }

    .VueTables__child-row-toggler {
      width: 16px;
      height: 16px;
      line-height: 16px;
      display: block;
      margin: auto;
      text-align: center;
    }

    .VueTables__child-row-toggler--closed::before {
      content: "+";
    }

    .VueTables__columns-dropdown {
      padding-right: 20px;
    }

    .VueTables__date-filter {
      border: 1px solid #ccc;
      padding: 6px;
      border-radius: 4px;
      cursor: pointer;
    }

    .VueTables__number-field {
      border: 4px solid #ccc;
      padding: 6px;
      border-radius: 4px;
      cursor: pointer;
    }

    .VueTables__child-row-toggler--open::before {
      content: "-";
    }
  }

</style>
